export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.d76c6f6a.worker.js");
}
